export default [{
  name: 'hcob',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaDadosContato: {},
        PessoaBanco: {},
        PessoaEndereco: {}
      },
      Parcela: {},
      TipoContrato: '',
    }
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaBanco: {},
          PessoaDadosContato: {},
          PessoaEndereco: {}
        },
        Parcela: {},
        PessoaDadosContato: {}
      }
      commit('model', data)
    }
  },
}]
